// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child","big-style":"big-style","ant-switch-handle":"ant-switch-handle","ant-switch-checked":"ant-switch-checked"};